// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ZdzA","signatureBlock":"Footer_signatureBlock__1EFCZ","signature":"Footer_signature__3AEVf"};